import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'antd/dist/antd.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// TODO remove this line after 21.05.2025
const shouldForceCleanup = new Date() < new Date('2025-05-21');

if (shouldForceCleanup) {
  serviceWorkerRegistration.unregister();

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const reg of registrations) {
        reg.unregister();
      }
    });
  }
} else {
  serviceWorkerRegistration.register();
}

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById('root'),
);
